module.exports = __webpack_public_path__ + "img/zahran-stamp.43d16664.png";